export const parseOrderItemsIntoRegistrationForms = (orderItems: any) => {
  const result: any = [];

  orderItems.forEach(orderItem => {
    if (!orderItem.ticketTypeId) return;

    orderItem.tickets.forEach(ticket => {
      result.push({
        id_order_item: orderItem.id,
        index: ticket.index,
        ticket_type_id: orderItem.ticketTypeId,
        name: orderItem.name,
        data: ticket.registrationForm,
        addons: ticket.addons,
        wallet_credit: ticket.walletCredit,
      });
    });
  });

  return result;
};
